/**
 * description: 描述信息
 * author: bql
 * 2023/8/1 14:48
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectPlanItemApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-plan-item'
    }

}